import axios, { isAxiosError } from 'axios';
import { API_ROUTES } from '@/config/api-routes';
function parsePhonePauseApiError(err, fallback) {
    if (!isAxiosError(err)) {
        return err instanceof Error ? err.message : fallback;
    }
    const data = err.response?.data;
    if (Array.isArray(data?.fieldErrors) && data.fieldErrors.length > 0) {
        return data.fieldErrors
            .map((fe) => fe.message || fe.field || 'Validation error')
            .join(' · ');
    }
    if (typeof data?.message === 'string' && data.message.trim()) {
        return data.message;
    }
    return err.message || fallback;
}
/** POST `/api/phone-pause` — pause inbound queue calls; agent stays available for outbound only. */
export async function pauseIncomingCallsOutgoingOnly() {
    const body = { status: 'OUTGOING_ONLY' };
    try {
        await axios.post(API_ROUTES.phonePause, body);
    }
    catch (err) {
        throw new Error(parsePhonePauseApiError(err, 'Could not pause incoming calls.'));
    }
}
/** GET `/api/phone-pause/status` — restore inbound pause toggle after login or hard refresh. */
export async function fetchPhonePauseStatus() {
    try {
        const { data } = await axios.get(API_ROUTES.phonePauseStatus);
        return data ?? {};
    }
    catch (err) {
        throw new Error(parsePhonePauseApiError(err, 'Could not load phone pause status.'));
    }
}
/** PUT `/api/phone-pause/clear` — end ACW (`null`) or allow inbound queue calls (`OUTGOING_ONLY`). */
export async function clearPhonePause(status = null) {
    const body = { status };
    try {
        const { data } = await axios.put(API_ROUTES.phonePauseClear, body);
        return data ?? {};
    }
    catch (err) {
        throw new Error(parsePhonePauseApiError(err, 'Could not update phone pause status.'));
    }
}
